<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="学员姓名">
        <el-input v-model="filters.MemberName" placeholder="请输入学员姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="学员手机">
        <el-input v-model="filters.MemberPhone" placeholder="请输入学员手机" clearable></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择审核状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="已通过" :value="1"></el-option>
          <el-option label="已驳回" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交时间">
        <el-date-picker
          v-model="filters.timeRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="item.Func && (item.Func.toLowerCase().indexOf('reject') !== -1) ? 'danger' :
                 item.Func && (item.Func.toLowerCase().indexOf('approve') !== -1) ? 'success' : 'primary'"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column prop="MemberName" label="学员姓名" width="100"></el-table-column>
      <el-table-column prop="MemberPhone" label="学员手机" width="120"></el-table-column>
      <el-table-column prop="CertificateName" label="申请证书" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="RuleName" label="规则名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="StatusName" label="审核状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.Status)" size="small">
            {{ scope.row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ApplyRemark" label="申请备注" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="AuditRemark" label="审核备注" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="AuditSysUserInfoName" label="审核人" width="100"></el-table-column>
      <el-table-column prop="AuditTime" label="审核时间" width="160" :formatter="formatAuditTime"></el-table-column>
      <el-table-column prop="CreateTime" label="提交时间" width="160" :formatter="formatCreateTime"></el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="showDetail(scope.row)">详情</el-button>
          <el-button
            v-if="scope.row.Status === 0"
            size="mini"
            type="text"
            style="color: #67c23a"
            @click="quickApprove(scope.row)"
          >通过</el-button>
          <el-button
            v-if="scope.row.Status === 0"
            size="mini"
            type="text"
            style="color: #f56c6c"
            @click="quickReject(scope.row)"
          >驳回</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--详情弹窗-->
    <el-dialog
      title="证书申请详情"
      :visible.sync="detailVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form v-if="detailData" label-width="100px" size="small" class="apply-detail-form">
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="学员姓名">
              <span>{{ detailData.MemberName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学员手机">
              <span>{{ detailData.MemberPhone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请证书">
              <span>{{ detailData.CertificateName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规则名称">
              <span>{{ detailData.RuleName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核状态">
              <el-tag :type="getStatusType(detailData.Status)" size="small">
                {{ detailData.StatusName }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提交时间">
              <span>{{ formatTime(detailData.CreateTime) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="申请备注">
              <span>{{ detailData.ApplyRemark || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="detailData.AuditSysUserInfoName">
            <el-form-item label="审核人">
              <span>{{ detailData.AuditSysUserInfoName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="detailData.AuditTime">
            <el-form-item label="审核时间">
              <span>{{ formatTime(detailData.AuditTime) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="detailData.AuditRemark">
            <el-form-item label="审核备注">
              <span>{{ detailData.AuditRemark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="margin-top: 16px;" v-if="detailData && detailData.ConditionProgressList && detailData.ConditionProgressList.length">
        <h4 style="margin: 0 0 8px 0;">规则条件 / 实时进度</h4>
        <el-table :data="detailData.ConditionProgressList" size="small" border>
          <el-table-column prop="Description" label="条件" min-width="180"></el-table-column>
          <el-table-column prop="ProgressText" label="进度" width="160"></el-table-column>
          <el-table-column label="是否满足" width="100">
            <template slot-scope="s">
              <el-tag :type="s.row.IsSatisfied ? 'success' : 'info'" size="mini">
                {{ s.row.IsSatisfied ? '已满足' : '未满足' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer" v-if="detailData && detailData.Status === 0">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="danger" @click="quickReject(detailData)">驳回</el-button>
        <el-button type="success" @click="quickApprove(detailData)">通过</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--审核弹窗(通过/驳回 共用，差异在 status 与提示文案)-->
    <el-dialog
      :title="auditForm.Status === 1 ? '审核通过' : '审核驳回'"
      :visible.sync="auditVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
        <el-form-item label="学员">
          <span>{{ currentRow ? currentRow.MemberName + '（' + currentRow.MemberPhone + '）' : '' }}</span>
        </el-form-item>
        <el-form-item label="证书">
          <span>{{ currentRow ? currentRow.CertificateName : '' }}</span>
        </el-form-item>
        <el-form-item
          label="审核备注"
          prop="AuditRemark"
          :rules="auditForm.Status === 2
            ? [{ required: true, message: '请填写驳回原因', trigger: 'blur' }]
            : []"
        >
          <el-input
            type="textarea"
            v-model="auditForm.AuditRemark"
            :rows="3"
            :placeholder="auditForm.Status === 1 ? '可选：审核通过备注' : '请填写驳回原因（必填）'"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button
          :type="auditForm.Status === 1 ? 'success' : 'danger'"
          :loading="submitLoading"
          @click="submitAudit"
        >
          {{ auditForm.Status === 1 ? '确认通过' : '确认驳回' }}
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  CertificateApplyGetList,
  CertificateApplyGet,
  CertificateApplyAudit,
} from '../../api/api'
import { formatDate } from '../../common/js/date'

export default {
  data() {
    return {
      filters: {
        MemberName: '',
        MemberPhone: '',
        Status: -1,
        timeRange: [],
      },
      tableData: [],
      listLoading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      currentRow: null,
      buttonList: [],

      detailVisible: false,
      detailData: null,

      auditVisible: false,
      submitLoading: false,
      auditForm: {
        Id: 0,
        Status: 1, // 1-通过 2-驳回
        AuditRemark: '',
      },
      auditRules: {},
    }
  },
  created() {
    this.getModules_search()
  },
  methods: {
    callFunc(item) {
      const fn = this[item.Func]
      if (typeof fn === 'function') {
        fn.call(this, item)
      }
    },
    async getModules_search() {
      this.listLoading = true
      const [start, end] = this.filters.timeRange || []
      const { data } = await CertificateApplyGetList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        MemberName: this.filters.MemberName,
        MemberPhone: this.filters.MemberPhone,
        Status: this.filters.Status,
        StartTime: start || null,
        EndTime: end || null,
      })
      if (data && data.success) {
        this.tableData = (data.response && data.response.data) || []
        this.total = (data.response && data.response.dataCount) || 0
        this.buttonList = (data.response && data.response.buttonList) || this.buttonList
        if (this.buttonList.length === 0) {
          this.buttonList = [
            { id: 1, name: '查询', Func: 'getModules_search' },
          ]
        }
      }
      this.listLoading = false
    },
    selectCurrentRow(row) {
      this.currentRow = row
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getModules_search()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules_search()
    },
    async showDetail(row) {
      const { data } = await CertificateApplyGet({ id: row.Id })
      if (data && data.success) {
        this.detailData = data.response
        this.detailVisible = true
      } else {
        this.$message.error((data && data.msg) || '获取详情失败')
      }
    },
    quickApprove(row) {
      this.currentRow = row
      this.auditForm = {
        Id: row.Id,
        Status: 1,
        AuditRemark: '',
      }
      this.auditVisible = true
    },
    quickReject(row) {
      this.currentRow = row
      this.auditForm = {
        Id: row.Id,
        Status: 2,
        AuditRemark: '',
      }
      this.auditVisible = true
    },
    handleApprove() {
      if (!this.currentRow) {
        this.$message.warning('请选择要通过的申请')
        return
      }
      if (this.currentRow.Status !== 0) {
        this.$message.warning('该申请已被审核')
        return
      }
      this.quickApprove(this.currentRow)
    },
    handleReject() {
      if (!this.currentRow) {
        this.$message.warning('请选择要驳回的申请')
        return
      }
      if (this.currentRow.Status !== 0) {
        this.$message.warning('该申请已被审核')
        return
      }
      this.quickReject(this.currentRow)
    },
    submitAudit() {
      this.$refs.auditForm.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          const { data } = await CertificateApplyAudit(this.auditForm)
          if (data && data.success) {
            this.$message.success(data.msg || '操作成功')
            this.auditVisible = false
            this.detailVisible = false
            this.getModules_search()
          } else {
            this.$message.error((data && data.msg) || '操作失败')
          }
        } finally {
          this.submitLoading = false
        }
      })
    },
    getStatusType(status) {
      const types = { 0: 'warning', 1: 'success', 2: 'danger' }
      return types[status] || 'info'
    },
    formatTime(time) {
      if (!time) return '-'
      return formatDate(new Date(time), 'yyyy-MM-dd hh:mm')
    },
    formatAuditTime(row) {
      return this.formatTime(row.AuditTime)
    },
    formatCreateTime(row) {
      return this.formatTime(row.CreateTime)
    },
  },
}
</script>

<style scoped>
.apply-detail-form .el-form-item {
  margin-bottom: 8px;
}
.apply-detail-form .el-form-item__content span {
  color: #303133;
}
</style>
